// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--Nl0lM";
export var wrapperOut = "styles-module--wrapperOut--TNbHT";
export var extra = "styles-module--extra--3jEz9";
export var mobileIn = "styles-module--mobileIn--r_AiR";
export var mobileOut = "styles-module--mobileOut--1-D9d";
export var desktopIn = "styles-module--desktopIn--1-8S6";
export var desktopOut = "styles-module--desktopOut--3NFPn";
export var conteudo = "styles-module--conteudo--2RJKf";
export var button = "styles-module--button--UCWjt";